import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Role } from '../_model/user';
import { AuthService } from './AuthService';
import { OrderService } from './OrderService';
import { Originentitytype } from '../_model/subscription';
import { filter, firstValueFrom, map } from 'rxjs';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const _authService = inject(AuthService)
  const _orderService = inject(OrderService)
  const _router = inject(Router)

  if (route.url[0] && (route.url[0].path === 'personalmenu' || route.url[0].path === 'recipefirst')) {

    if (!_authService.isAuthenticatedValue) return true;

    //user is logged in and wants to go to /personalmenu
    if(localStorage.getItem('skipcheck')) return true

    //if the user has no subscriptionorders, he can continue
    return firstValueFrom(_orderService.OrderlistSubject.pipe(
      filter(orders => orders !== null), //makes sure that there are orders loaded
      map(orders => {
        const hasRecipeSubscriptionOrders = orders.filter(o => o.originentityid && o.originentitytype === Originentitytype.RECIPE_SUBSCRIPTION).length > 0;
        return !hasRecipeSubscriptionOrders; //should revert given value
      })
    )).then(val => {
      if (val)
        return true;

      _router.navigate(['user']);
      return false;
    })
  }
  if (route.url[0] && route.url[0].path === 'telemarketing') {
    //check if the telemarketing people can goto the telemarketing page
    if (_authService.isAuthenticated() && _authService.hasRole(Role.TELEMARKETING)) {
      return true;
    } else if (!_authService.isAuthenticated()) {
      if (state.url) {
        const reg = RegExp(/returnUrl=.*/gm)
        const url = state.url.toString().replace(reg, "");
        _router.navigate(['login'], { queryParams: { returnUrl: url } });
      }
      return false;
    } else {
      _router.navigate(['']);
    }
  }

  //catchall for all routes that have a canActivate Authguard
  if (!_authService.isAuthenticated()) {
    if (state.url) {
      const reg = RegExp(/returnUrl=.*/gm)
      const url = state.url.toString().replace(reg, "");
      _router.navigate(['login'], { queryParams: { returnUrl: url } });
    }
    return false;
    //always navigates the telemarketing users to the telemarketing page, they shouldnt do anything else
  } else if (
    !state.url.startsWith('/telemarketing') && _authService.hasRole(Role.TELEMARKETING)
  ) {
    _router.navigate(['telemarketing']);
    return false;
  }

  return true;
}